import { Button } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const PopupButtons = function ({ hasOverride, isDisabled, save, value }) {
    const onClickRemove = React.useCallback(() => {
        (async () => save(undefined))();
    }, [save]);
    const onClickSave = React.useCallback(() => {
        (async () => save(value))();
    }, [save, value]);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(Button, { disabled: isDisabled, onClick: onClickSave }, "SAVE"),
        hasOverride ?
            React.createElement(Button, { onClick: onClickRemove, variant: 'secondary' }, "REMOVE") : undefined));
};
export default PopupButtons;
